module.exports = __webpack_public_path__ + "static/media/ombori_grid_large_white.08e2467a.svg";